import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation, useRoute } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { Text, View, Modal, ActivityIndicator } from 'react-native';

import GradientButton from '../../components/GradientButton';
import HeaderDefault from '../../components/HeaderDefault';
import ModalSuccess from '../../components/ModalSuccess';
import paymentService from "../../services/paymentService";
import { formatCoin } from '../../utils/formatNumber';
import toast from '../../utils/toast';

import { styles } from './styles';

const DepositCreditCardSummary = () => {
  const [value, setValue] = useState(0);

  const navigation = useNavigation();
  const route = useRoute();

  const [selectedCard, setSelectedCard] = useState();
  const [creditCard, setCreditCard] = useState();
  const [creditCardHolderInfo, setCreditCardHolderInfo] = useState();

  const [isLoading, setIsLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    (async () => {
      const value = parseFloat(await AsyncStorage.getItem('depositAmount'));
      setValue(value);
    })();

    const { selectedCard, creditCard, creditCardHolderInfo } = route.params;
    setSelectedCard(selectedCard);
    setCreditCard(creditCard);
    setCreditCardHolderInfo(creditCardHolderInfo);
  }, []);

  async function createCreditCardPayment() {
    setIsLoading(true);
    const token = await AsyncStorage.getItem('JWT_TOKEN');
    try {
      if (selectedCard)
        await paymentService.createWithExistingCreditCard(token, value, selectedCard.id);
      else
        await paymentService.createWithNewCreditCard(token, value, creditCard, creditCardHolderInfo);

      setModalVisible(true);
    } catch (err) {
      console.log(err.response.data);
      if (err.response.data.message)
        toast(err.response.data.message, "#DA1414");
      else
        toast('Algo deu errado. Por favor, tente novamente mais tarde.', "#DA1414");
    } finally {
      setIsLoading(false);
    }
  }

  const cardNumber = selectedCard ? selectedCard.number : (creditCard ? creditCard.number.substring(creditCard.number.length - 4) : '****');

  return (
    <>
      <View style={{ flex: 1 }}>
        <HeaderDefault title={"Depositar BRL"} />
        <View style={styles.container}>
          <View>
            <Text style={styles.title}>Revisar informações de pagamento</Text>
            <View style={styles.headerInfo}>
              <View>
                <Text style={styles.subtitle}>Depósito no cartão de crédito</Text>
                <Text style={styles.value}>R$ {formatCoin(value)}</Text>
              </View>
            </View>
            <View style={styles.cardInfo}>
              <View>
                <Text>Cartão de crédito</Text>
                <Text style={styles.subtitle}>**** **** **** {cardNumber}</Text>
              </View>
            </View>
          </View>

          <View style={styles.buttons}>
            {
              isLoading ?
                <ActivityIndicator color="#1FBFB5" size="large" />
                :
                <GradientButton onPress={createCreditCardPayment} style={styles.useSelectedButton}>Finalizar pagamento</GradientButton>
            }
          </View>
        </View>
      </View>

      <Modal
        animationType="fade"
        transparent={false}
        visible={modalVisible}
        statusBarTranslucent={true}
        onRequestClose={() => setModalVisible((visible) => !visible)}
      >
        <ModalSuccess
          handleCloseModal={() => {
            setModalVisible(false);
            navigation.navigate('Home');
          }}
          text={"Pagamento efetuado com "}
          textColor={"sucesso!"}
          img={2}
          positionHeader={"left"}
        />
      </Modal>
    </>
  );
}

export default DepositCreditCardSummary;